import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Printer } from "lucide-react";
import { api, apiError } from "@/lib/api";
import { formatTRY } from "@/lib/format";

// Alış İade Belgesi – yazdırma sayfası (satış faturası yazdırma sayfasıyla aynı düzen)
export default function PurchaseReturnPrint() {
  const { id } = useParams();
  const [r, setR] = useState(null);
  const [err, setErr] = useState("");
  useEffect(() => { api.get(`/purchase-returns/${id}`).then(({ data }) => setR(data)).catch((e) => setErr(apiError(e))); }, [id]);
  if (err) return <div className="p-8 text-rose-700" data-testid="pr-print-error">{err}</div>;
  if (!r) return <div className="p-8 text-slate-500" data-testid="pr-print-loading">Belge yükleniyor…</div>;
  const rev = r.status === "ters_kayit";
  return (
    <div className="bg-white min-h-screen p-8 print:p-0 text-slate-900" data-testid="pr-print-page">
      <div className="max-w-[800px] mx-auto">
        <div className="flex justify-end mb-4 print:hidden"><button className="h-9 px-4 rounded bg-slate-900 text-white text-sm inline-flex items-center gap-2" onClick={() => window.print()} data-testid="pr-print-button"><Printer className="h-4 w-4" />Yazdır</button></div>
        <div className="flex justify-between items-start border-b-2 border-slate-900 pb-3 mb-4">
          <div className="text-xl font-bold tracking-tight">İMAMOĞLU A.Ş</div>
          <div className="text-right">
            <div className="text-lg font-bold uppercase" data-testid="print-doc-title">{rev ? "Alış İadesi Ters Kayıt" : "Alış İade Belgesi"}</div>
            <div className="font-mono text-sm" data-testid="pr-print-no">{r.no}</div>
            <div className="text-[11px] text-slate-500">Tarih {r.date}{r.status === "iptal" ? ` · Ters kayıtla iptal (${r.reversed_no})` : ""}{rev ? ` · Asıl belge ${r.reversal_of_no}` : ""}</div>
          </div>
        </div>
        <div className="text-[13px] space-y-0.5 mb-4">
          <div>Tedarikçi: <b>{r.supplier_code} – {r.supplier_name}</b></div>
          {r.po_no && <div>Satın alma: <b className="font-mono">{r.po_no}</b></div>}
          <div>İade nedeni: {r.reason}</div>
          {r.refund && <div>İade bedeli tahsili: <b>{formatTRY(r.refund.amount)}</b> → {r.refund.account_name}</div>}
        </div>
        <table className="w-full text-[12px] border-collapse">
          <thead><tr className="border-b border-slate-400 text-left"><th className="py-1">SKU</th><th>Ürün</th><th className="text-right">Miktar</th><th className="text-right">Birim maliyet</th><th className="text-right">Tutar</th></tr></thead>
          <tbody>{r.lines.map((l) => (
            <tr key={l.product_id} className="border-b border-slate-200"><td className="py-1 font-mono">{l.sku}</td><td>{l.name}</td><td className="text-right">{l.qty}</td><td className="text-right">{formatTRY(l.unit_cost_try)}</td><td className="text-right">{formatTRY(l.total_try)}</td></tr>))}</tbody>
        </table>
        <div className="text-right mt-3 text-[15px]">Toplam: <b data-testid="pr-print-total">{formatTRY(r.total_try)}</b></div>
        <p className="text-[11px] text-slate-500 mt-4">{r.cost_rule}</p>
        <div className="grid grid-cols-2 gap-8 mt-12 text-[12px]">{["Teslim Eden", "Teslim Alan (Tedarikçi)"].map((x) => <div key={x} className="border-t border-slate-400 pt-1 text-center text-slate-600">{x}</div>)}</div>
        <div className="text-[10px] text-slate-400 mt-6">Düzenleyen: {r.created_by_name}</div>
      </div>
    </div>
  );
}
